module.exports = __webpack_public_path__ + "img/error2.4ebc6c6a.png";